'use client';

import React from 'react';
import { Grid2 as Grid } from '@unity/cloud-ui';
import z from 'zod';
import { getComponentDocumentationUrl } from '@/utils/get-component-doc-url';

const CardGrid = (props: z.input<typeof cardGridSchema>) => {
  const { cols = 2 } = props;

  return (
    <Grid container spacing={2} sx={{ py: 2 }}>
      {React.Children.map(props.children, (child, index) => {
        if (!React.isValidElement(child)) {
          return null;
        }
        return (
          <Grid key={index} size={{ xs: 12, md: 12 / cols }}>
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
};

const documentationUrl = getComponentDocumentationUrl('card-grids');

const descriptions = {
  cardGrid: {
    cols: 'The number of columns to display the cards in.',
    children: 'The content of the card grid',
    schema: `Display a grid of cards. \n\n\n\n**Example**\n\`\`\`mdx\n<CardGrid cols={3}>\n  <Card title="Title" iconSrc="[href]" alt="[altText]" href="[href]">\n    The content of the card\n  </Card>\n</CardGrid>\n\`\`\`\n\n${documentationUrl}`,
  },
};

export const cardGridSchema = z
  .object({
    cols: z.number().describe(descriptions.cardGrid.cols).optional(),
    children: z.any().describe(descriptions.cardGrid.children),
  })
  .describe(descriptions.cardGrid.schema);

export default CardGrid;
